/**
 * Custom error class for Deepgram transcription setup failures (non-API key errors).
 * Used to distinguish transcription setup errors from other errors in error handling.
 */
export class DeepgramTranscriptionSetupError extends Error {
  constructor(
    message: string,
    public readonly originalError?: unknown,
  ) {
    super(message);
    this.name = 'DeepgramTranscriptionSetupError';
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, DeepgramTranscriptionSetupError);
    }
  }
}
